<template>
  <div>
    <NavBar :admin="true" :items="items" />
    <v-main>
      <v-container v-if="!loading">
        <p class="text-h5 mt-2" v-translate>Terms and Conditions</p>
        PT
        <RichTextEditor key="pt" ref="editorPT" :text="terms_conditions_pt" />
        EN
        <RichTextEditor key="en" ref="editorEN" :text="terms_conditions_en" />
        ES
        <RichTextEditor key="es" ref="editorES" :text="terms_conditions_es" />
        <v-row no-gutters class="mt-2">
          <v-alert v-model="error" color="red" icon="warning">
						<translate>Error</translate>
					</v-alert>
          <v-spacer></v-spacer>
          <v-btn depressed color="primary" @click="save" :loading="loading">
            <translate>Save</translate>
          </v-btn>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import NavBar from "@/components/authentication/NavBar.vue";
import RichTextEditor from "@/components/RichTextEditor.vue";
import axios from "axios";

export default {
  name: "TermsConditions",
  components: {
    NavBar,
    RichTextEditor
  },
  data: () => ({
    terms_conditions_pt: "",
    terms_conditions_en: "",
    terms_conditions_es: "",
    loading: true,
    error: false
  }),
  computed: {
		items() {
			return [
				{
					text: this.$gettext("Dashboard"),
					disabled: false,
					link: true,
					to: "/admin/dashboard"
				},
				{
					text: this.$gettext("Terms and Conditions"),
					disabled: true,
					link: true
				}
			];
    },
    required() {
			return value => !!value || this.$gettext("Required.");
		}
  },
  methods: {
    save() {
      this.loading = true;
      let text_pt = this.$refs.editorPT.getHTML();
      let text_en = this.$refs.editorEN.getHTML();
      let text_es = this.$refs.editorES.getHTML();
      console.log(text_pt, text_en, text_es);
      const formData = new FormData();
      formData.append("terms_conditions_pt", text_pt);
      formData.append("terms_conditions_en", text_en);
      formData.append("terms_conditions_es", text_es);
      axios
        .post("/admin/terms-conditions", formData)
        .then(response => {
          console.log(response.data);
          if (response.status === 200) {
            this.terms_conditions_pt = response.data.terms_conditions_pt;
            this.terms_conditions_en = response.data.terms_conditions_en;
            this.terms_conditions_es = response.data.terms_conditions_es;
            this.loading = false;
          }
        })
        .catch(error => {
          console.log(error);
          this.loading = false;
          this.error = true;
        });
    }
  },
  created() {
		axios
      .get("/admin/terms-conditions")
      .then(response => {
        console.log(response.data);
        if (response.status === 200) {
          this.terms_conditions_pt = response.data.terms_conditions_pt;
          this.terms_conditions_en = response.data.terms_conditions_en;
          this.terms_conditions_es = response.data.terms_conditions_es;
          this.loading = false;
        }
      })
      .catch(error => {
        console.log(error)
        this.loading = false;
        this.error = true;
      });
  }
}
</script>